import { render, staticRenderFns } from "./Logo_ACU.vue?vue&type=template&id=dab4e706&scoped=true&"
var script = {}
import style0 from "./Logo_ACU.vue?vue&type=style&index=0&id=dab4e706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab4e706",
  null
  
)

export default component.exports